import { API_ROUTES } from '@/api/apiRoutes';
import { safeAxios } from '@/services/safeAxios';

export interface CommunityPublishVersion {
  version: number;
  createdAt: string;
  publishedAt?: string;
}

export interface PrepareCommunityPublishResponse {
  frozenVersion: CommunityPublishVersion;
  draftVersion: CommunityPublishVersion;
  updatedAt: string;
}

export async function prepareCommunityPublishSnapshot(
  workflowId: string,
  isPublishingAsTool = false,
  destination?: 'community' | 'org',
): Promise<PrepareCommunityPublishResponse> {
  // For Community, publishAsTool tells the backend to report content-scan verdicts for the tool
  // instead of the workflow. Org preparation freezes the version and checks models without scanning.
  const { data } = await safeAxios.post<PrepareCommunityPublishResponse>(
    API_ROUTES.recipes.prepareCommunityPublish({ recipeId: workflowId }),
    { publishAsTool: isPublishingAsTool, ...(destination ? { destination } : {}) },
  );
  return data;
}
